module.exports = Array.isArray;
